(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-faq-root]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var items = root.querySelectorAll('[data-faq-item]');
      if (!items.length) return;

      function closeItem(item) {
        item.classList.remove('is-open');
        var head = item.querySelector('[data-faq-head]');
        var body = item.querySelector('[data-faq-body]');
        if (head) head.setAttribute('aria-expanded', 'false');
        if (body) body.style.maxHeight = '0px';
      }

      function openItem(item) {
        item.classList.add('is-open');
        var head = item.querySelector('[data-faq-head]');
        var body = item.querySelector('[data-faq-body]');
        if (head) head.setAttribute('aria-expanded', 'true');
        if (body) {
          var inner = body.firstElementChild;
          var target = inner ? inner.scrollHeight + 8 : body.scrollHeight;
          body.style.maxHeight = target + 'px';
        }
      }

      items.forEach(function (item) {
        var head = item.querySelector('[data-faq-head]');
        if (!head) return;
        head.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          root.querySelectorAll('[data-faq-item].is-open').forEach(function (open) {
            if (open !== item) closeItem(open);
          });
          if (willOpen) openItem(item);
          else closeItem(item);
        });
      });

      // Open the first item by default (already marked .is-open server-side)
      var initiallyOpen = root.querySelector('[data-faq-item].is-open');
      if (initiallyOpen) {
        // Defer so fonts/layout settle before measuring scrollHeight
        requestAnimationFrame(function () {
          var body = initiallyOpen.querySelector('[data-faq-body]');
          if (body) {
            var inner = body.firstElementChild;
            var target = inner ? inner.scrollHeight + 8 : body.scrollHeight;
            body.style.maxHeight = target + 'px';
          }
        });
      }

      // Entrance reveal handled by the shared custom-reveal.js
    });

    // Re-measure open bodies on resize so content keeps fitting
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[data-faq-item].is-open [data-faq-body]').forEach(function (body) {
          var inner = body.firstElementChild;
          var target = inner ? inner.scrollHeight + 8 : body.scrollHeight;
          body.style.maxHeight = target + 'px';
        });
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
